import { useContext, useState } from 'react';
import { Box, Button, Icon, Menu, MenuItem } from '@mui/material';

import SearchInput from 'Lib/muiComponents/common/SearchInput';

import NotesContext from './context';
import { SORT_TYPES } from './Notes';
import { NewNoteButton } from './styledComponents';

export const Header = ({ isLoading, handlePrintAll, onSort, onSearch, toggleAdd }) => {
    const { sort, search, showForm } = useContext(NotesContext);

    const [sortAnchorElement, setSortAnchorElement] = useState(null);

    const handleSearch = value => {
        onSearch(value);
    };

    if (showForm) return null;

    return (
        <Box sx={{ textAlign: 'center', px: 4 }}>
            <NewNoteButton variant="primary" onClick={toggleAdd} sx={{ float: 'left', my: 4 }}>
                Create a New Note
            </NewNoteButton>
            <SearchInput
                label="Search"
                value={search}
                placeholder="Search Notes"
                isLoading={isLoading}
                onChange={value => {
                    handleSearch(value);
                }}
            />
            <Box display="flex" justifyContent="space-between" m="4px -8px">
                <Button
                    variant="text"
                    endIcon={<Icon>{sortAnchorElement ? 'expand_less' : 'expand_more'}</Icon>}
                    sx={{ color: 'common.black', textTransform: 'inherit' }}
                    onClick={event => setSortAnchorElement(event.currentTarget)}
                >
                    Sort by: {sort}
                </Button>
                <Menu
                    anchorEl={sortAnchorElement}
                    open={Boolean(sortAnchorElement)}
                    onClose={() => setSortAnchorElement(null)}
                    disablePortal
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                >
                    {Object.entries(SORT_TYPES).map(([key, label]) => (
                        <MenuItem
                            key={key}
                            onClick={() => {
                                onSort(key);
                                setSortAnchorElement(null);
                            }}
                        >
                            {label}
                        </MenuItem>
                    ))}
                </Menu>
                <Button variant="text" startIcon={<Icon>print</Icon>} sx={{ color: 'common.black', textTransform: 'inherit' }} onClick={handlePrintAll}>
                    Print all notes
                </Button>
            </Box>
        </Box>
    );
};
